













import { Vue, Component, Prop } from 'vue-property-decorator'
import { marquee } from '$services/index'

/**
 * @onLoad 暴露了一个组件初始化完成的事件
 * 用来父级展示控制
 * <div v-show="showMarquee"> // 这里一定要用v-show v-if是不会加载Marquee的
 *  // icon 之类的自己做的东西
 *  <Marquee @onLoad="showMarquee = true"/>
 * </div>
 */

@Component
export default class Marquee extends Vue {
  @Prop({ default: '' }) readonly actCode!: string

  @Prop({ default: false }) readonly sort!: boolean

  @Prop({ default: 3000 }) readonly viewTime!: number

  @Prop({ default: 25 }) readonly height!: number

  transitionDuration: string = '600ms'

  transform: number = 0

  scrollList: readonly any[] = []

  interval: number | null = 0

  timeout: number = 0

  get showHeight() {
    return this.height / 40
  }

  visibilityHandler() {
    if (document.visibilityState === 'visible') {
      this.addAnimation()
    } else {
      this.removeAnimation()
    }
  }

  /** 获取跑马灯数据 */
  getMarqueeData() {
    const promiseList = this.actCode.split(',').map((code) => {
      return marquee({ actCode: code })
    })
    return Promise.all(promiseList)
      .then((dataArray) => {
        return dataArray.reduce((ret, data) => {
          ret.push(
            ...data.map((el: any) => { return el.content })
          )
          return ret
        }, [])
      })
      .catch((e) => {
        console.log('[marquee.vue] error', e)
        return []
      })
  }

  async initScrollList() {
    const data = await this.getMarqueeData()
    if (this.sort) {
      data.sort()
    }
    if (data[0]) {
      data.push(data[0])
    }
    this.scrollList = Object.freeze([...data])
  }

  removeAnimation() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  addAnimation() {
    if (this.interval) {
      return
    }
    const max = this.scrollList.length - 1
    this.interval = setInterval(() => {
      this.transitionDuration = '600ms'
      this.transform++
      if (this.transform >= max) {
        this.timeout = setTimeout(() => {
          this.transitionDuration = '0ms'
          this.transform = 0
        }, 600)
      }
    }, this.viewTime)
  }

  async init() {
    await this.initScrollList()
    if (this.scrollList.length === 0) {
      return
    }
    this.$emit('onLoad')
    this.addAnimation()
  }

  created() {
    !this.actCode && console.log('[marquee.vue]', 'actCode 为必传项')
    this.viewTime < 1000 && console.log('[marquee.vue]', 'viewTime 最小1000ms')
  }

  mounted() {
    document.addEventListener('visibilitychange', this.visibilityHandler)
    this.$nextTick(() => {
      this.init()
    })
  }

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.visibilityHandler)
    this.interval && clearInterval(this.interval)
    this.timeout && clearTimeout(this.timeout)
  }
}
